import { render, staticRenderFns } from "./ViewTemplateSettings.vue?vue&type=template&id=e07b0dd8&scoped=true"
import script from "./ViewTemplateSettings.vue?vue&type=script&lang=js"
export * from "./ViewTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplateSettings.vue?vue&type=style&index=0&id=e07b0dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07b0dd8",
  null
  
)

export default component.exports